import React, { useState, useEffect, forwardRef } from "react";
import { Row, Col, Descriptions, Divider, Tag, Button, Image, Space, QRCode } from 'antd';
import moment from "moment";
import Moment from "react-moment";
import { PrinterFill, GeoAltFill, EnvelopeAtFill, TelephoneFill, Globe } from 'react-bootstrap-icons';
import Footer from "./pieces/Footer";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CrDisplay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check;

  var PrintElem = function PrintElem(elem) {
    alert("try printing");
    var mywindow = window.open('', 'PRINT', 'height=auto,width=auto');
    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('<link rel="stylesheet" href="css/app.css" type="text/css" />');
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById(elem).innerHTML);
    mywindow.document.write('</body></html>');
    mywindow.document.close(); // necessary for IE >= 10

    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();
    return true;
  };

  var customer = check != null ? check.customer : null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      id: "printable",
      ref: ref,
      style: {
        padding: '28px'
      },
      children: /*#__PURE__*/_jsx(Row, {
        gutter: 16,
        children: /*#__PURE__*/_jsxs(Col, {
          span: 24,
          children: [/*#__PURE__*/_jsx(DocumentHeader, {
            title: "COMPTE RENDU MEDICAL"
          }), /*#__PURE__*/_jsx(Row, {
            gutter: 16,
            children: /*#__PURE__*/_jsxs(Col, {
              children: [/*#__PURE__*/_jsx("div", {
                className: "cool-radius",
                style: {
                  background: '#FEE8A4'
                },
                children: check && customer && /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    labelStyle: {
                      fontWeight: 'Bold'
                    },
                    span: 2,
                    contentStyle: {
                      fontWeight: 'Bold'
                    },
                    label: "ID PATIENT",
                    children: customer.idnumber
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Pr\xE9nom"
                    }),
                    children: customer.firstname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Nom"
                    }),
                    children: customer.lastname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Tel."
                    }),
                    children: customer.mobile.toString().slice(3)
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Genre"
                    }),
                    children: customer.gender == 'F' ? "Femme" : "Homme"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Age"
                    }),
                    children: "customer.birthdate"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Profession"
                    }),
                    children: customer.job
                  })]
                })
              }), /*#__PURE__*/_jsx(Divider, {}), check && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(Descriptions, {
                  column: 4,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "CONSTANTES"
                  }),
                  children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Poids"
                    }),
                    children: [check.weight, " Kg"]
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Tension"
                    }),
                    children: [check.ta, " mmHg"]
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Pouls"
                    }),
                    children: [check.pulse, " Pouls/Min"]
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Temperature"
                    }),
                    children: [check.temperature, " \xB0C"]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "SpO2"
                    }),
                    children: check.spO2
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Glycemie"
                    }),
                    children: [check.glycemy, " g/L"]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "TT"
                    }),
                    children: check.tt
                  })]
                }), /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "PLAINTE"
                  }),
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Motif"
                    }),
                    children: check.reason != '' && check.reason != null ? check.reason : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Histoire de la maladie"
                    }),
                    children: check.traitement_anterieur != '' && check.traitement_anterieur != null ? check.traitement_anterieur : '--'
                  })]
                }), /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "ANTECEDANTS PERSONNELS"
                  }),
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Medicaux"
                    }),
                    children: check.ant_medicals != '' && check.ant_medicals != null ? check.ant_medicals : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Chirugicaux"
                    }),
                    children: check.ant_chirugicals != '' && check.ant_chirugicals != null ? check.ant_chirugicals : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Gyn\xE9co-obstetrique"
                    }),
                    children: check.ant_gyn != '' && check.ant_gyn != null ? check.ant_gyn : '--'
                  })]
                }), /*#__PURE__*/_jsx(Descriptions, {
                  column: 2,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "ANTECEDANTS FAMILIAUX"
                  }),
                  children: /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {}),
                    children: check.ant_family != '' && check.ant_family != null ? check.ant_family : '--'
                  })
                }), /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "EXAMENS"
                  }),
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen g\xE9n\xE9ral"
                    }),
                    children: check.exam_general
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen neurologique"
                    }),
                    children: check.exam_neuro != '' && check.exam_neuro != null ? check.exam_neuro : "--"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen cardiovasculaire"
                    }),
                    children: check.exam_cardio != '' && check.exam_cardio != null ? check.exam_cardio : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen rhumatologique"
                    }),
                    children: check.exam_rhuma != '' && check.exam_rhuma != null ? check.exam_rhuma : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen pleuropulmonaire"
                    }),
                    children: check.exam_pleuro != '' && check.exam_pleuro != null ? check.exam_pleuro : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen cutan\xE9o-phan\xE9rien"
                    }),
                    children: check.exam_cutaneo != '' && check.exam_cutaneo != null ? check.exam_cutaneo : '--'
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Examen ailleurs"
                    }),
                    children: check.exam_other != '' && check.exam_other != null ? check.exam_other : '--'
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "R\xE9sum\xE9 Syndromique"
                    })
                  }), /*#__PURE__*/_jsx("p", {
                    children: check.resum_syndrome
                  }), /*#__PURE__*/_jsx(Divider, {})]
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Hypoth\xE8ses diagnostiques"
                    })
                  }), /*#__PURE__*/_jsx("p", {
                    children: check.hypo_diagnostic
                  }), /*#__PURE__*/_jsx(Divider, {})]
                }), /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  borderdred: true,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "CONCLUSION"
                  }),
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Diagnostic retenu"
                    }),
                    children: check.final_diagnostic
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Traitements"
                    }),
                    children: check.treatments != '' && check.treatments != null ? check.treatments : "--"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Recommandations"
                    }),
                    children: check.recommandations != '' && check.recommandations != null ? check.recommandations : "--"
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 8,
                    md: 8,
                    sm: 9,
                    xs: 12,
                    children: /*#__PURE__*/_jsx(QRCode, {
                      value: "https://cliniqueadmin.com/#/checkmcheck/" + check.id.toString()
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: {
                      span: 10,
                      offset: 6
                    },
                    md: {
                      span: 12,
                      offset: 4
                    },
                    sm: {
                      span: 10,
                      offset: 6
                    },
                    children: /*#__PURE__*/_jsxs("div", {
                      style: {
                        textAlign: "center"
                      },
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Le Medecin"
                        })
                      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                        children: check.user.firstname + " " + check.user.lastname
                      }), /*#__PURE__*/_jsx("br", {})]
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Footer, {})]
              })]
            })
          })]
        })
      })
    })
  });
});
export default CrDisplay;